import { render, staticRenderFns } from "./ToDoEmptyState.vue?vue&type=template&id=0df15cf3&scoped=true"
import script from "./ToDoEmptyState.vue?vue&type=script&lang=js"
export * from "./ToDoEmptyState.vue?vue&type=script&lang=js"
import style0 from "./ToDoEmptyState.vue?vue&type=style&index=0&id=0df15cf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df15cf3",
  null
  
)

export default component.exports